module.exports = __webpack_public_path__ + "img/ship-ref.4a1613c3.svg";